/**
 * Manage template data
 */
import Ajax from '@/lib/ajax_wrapper'

const TEMPLATES_PATH = '/admin/site_templates'

/**
 * Read paginated templates
 *
 * @returns {promise}
 */
export function readTemplatesData() {
  return Ajax.request({
    url: TEMPLATES_PATH
  })
}

/**
 * Create a template
 *
 * @param {object} template
 * @param {string} template.name
 *
 * @returns {promise}
 */
export function createTemplateData(template) {
  return Ajax.request({
    url: TEMPLATES_PATH,
    method: 'POST',
    data: template
  })
}

/**
 * Read a template
 *
 * @param {string} id
 *
 * @returns {promise}
 */
export function readTemplateData(id) {
  return Ajax.request({
    url: `${TEMPLATES_PATH}/${id}`
  })
}

/**
 * Read a template
 *
 * @param {string} id
 *
 * @returns {promise}
 */
export function readTemplateDataBySlug(slug) {
  return Ajax.request({
    url: `${TEMPLATES_PATH}/slug/${slug}`
  })
}

/**
 * Update a template
 *
 * @param {string} id
 * @param {object} template
 * @param {string} template.name
 *
 * @returns {promise}
 */
export function updateTemplateData(id, template) {
  return Ajax.request({
    url: `${TEMPLATES_PATH}/${id}`,
    method: 'PATCH',
    data: template
  })
}

/**
 * Delete a template
 *
 * @param {string} id
 *
 * @returns {promise}
 */
export function deleteTemplateData(id) {
  return Ajax.request({
    url: `${TEMPLATES_PATH}/${id}`,
    method: 'DELETE'
  })
}
